import React from 'react';
import { Popover, Card, CardContent } from "../../styles/MaterialUI";

const CustomTooltip = ({ anchorEl, open, handleClose, content }) => {
    return (
        <Popover sx={{ pointerEvents: 'none' }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={handleClose}
            disableRestoreFocus
            disablePortal={true}  // Keep it within the DOM hierarchy to manage positioning
        >
            <Card sx={{ maxWidth: 600, maxHeight: 200, overflowY: 'auto' }}>
                <CardContent>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                </CardContent>
            </Card>
        </Popover>
    );
};

export default CustomTooltip;
